import React, { useEffect, useState } from "react";
import "./style.css";
import { useNavigate } from "react-router-dom";
import { Badge, Button, Drawer } from "antd";
import { Avatar, Menu, Popover } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { AiOutlineBell, AiOutlineMenu } from "react-icons/ai";
import { MdOutlineChatBubbleOutline } from "react-icons/md";
import Notification from "./notification";
import NotificationAPI from "../../api/notification";
import logo from "../../assets/logo_transparent.svg";
import useWindowDimensions from "../../utils/getWindowDimenssions";

const Navbar = ({ user }) => {
  const { height, width } = useWindowDimensions();
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const getNotifications = async (id) => {
    let res = await NotificationAPI.getNotifications(id);
    if (res.status == 200) {
      setData(res.data.reverse());
    }
  };
  // const [currentUser, setCurrentUser] = useState(null);

  // const getCurrentUser = async () => {
  //   try {
  //     const user = JSON.parse(localStorage.getItem("user"));
  //     const res = await api.get(`/auth/current-user/${user?._id}`);
  //     // debugger;
  //     setCurrentUser(res?.data?.data);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  useEffect(() => {
    if (user) getNotifications(user?._id);
  }, []);

  return (
    <div className="navbar_main">
      <div style={{ display: "flex", alignItems: "center", columnGap: "12px" }}>
        <img src={logo} className="logoNav" alt="logo" />
        <div className="logo_header">
          <span>SUCCESS CLUB</span>
        </div>
      </div>

      <div className="desktop_menu">
        {user ? (
          <div
            style={{ display: "flex", alignItems: "center", columnGap: "8px" }}
          >
            <Popover
              content={
                <Notification user={user} data={data} setData={setData} />
              }
              placement="bottomLeft"
              trigger="click"
            >
              <Badge count={data?.filter((el) => !el?.read).length}>
                <AiOutlineBell size={32} cursor="pointer" />
              </Badge>
            </Popover>
            <Popover
              content={
                <Menu>
                  <Menu.Item onClick={() => navigate("/history")}>
                    Profile
                  </Menu.Item>
                  <Menu.Item
                    onClick={() => {
                      localStorage.removeItem("user");
                      window.location.href = "/login";
                    }}
                  >
                    Logout
                  </Menu.Item>
                </Menu>
              }
              trigger="click"
            >
              <Avatar shape="circle" icon={<UserOutlined />} size={32} />
            </Popover>
            {user?.role !== "admin" && (
              <MdOutlineChatBubbleOutline
                size={30}
                onClick={() => navigate("/dashboard/chat")}
                cursor="pointer"
              />
            )}
          </div>
        ) : (
          <>
            {width > 500 && (
              <div>
                <button
                  className="nav_bar_button"
                  onClick={() => navigate("/buy-adspace")}
                >
                  Magazine
                </button>
                <button
                  className="nav_bar_button"
                  onClick={() => navigate("/login")}
                >
                  Login
                </button>
                <button
                  className="nav_bar_button"
                  onClick={() => navigate("/onBoarding")}
                >
                  Signup
                </button>
              </div>
            )}
          </>
        )}
      </div>

      {/* Mobile Menu */}
      {width < 500 && (
        <div className="mobile_menu">
          <AiOutlineMenu
            size={32}
            onClick={() => setVisible(true)}
            cursor="pointer"
          />
          <Drawer
            placement="right"
            onClose={() => setVisible(false)}
            open={visible}
            width={150}
          >
            <div
              style={{ display: "flex", flexDirection: "column", rowGap: 10 }}
            >
              <button
                className="nav_bar_button"
                onClick={() => navigate("/buy-adspace")}
              >
                Magazine
              </button>
              <button
                className="nav_bar_button"
                onClick={() => navigate("/login")}
              >
                Login
              </button>
              <button
                className="nav_bar_button"
                onClick={() => navigate("/onBoarding")}
              >
                Signup
              </button>
            </div>
          </Drawer>
        </div>
      )}
    </div>
  );
};

export default Navbar;
